export const TASKS_GROUP_BY = {
  ASSIGNEE: 'task_assignee',
  LEAD: 'task_lead',
  DUE_DATE: 'due_date',
}

export const STATUS_FILTER_VALUES = {
  OPEN: 'open',
  SNOOZED: 'snoozed',
  CLOSED: 'closed',
  ALL: 'all',
}
